import { createRoot } from 'react-dom/client';
import App from './App';
import { store } from '../resources/store';
import { Provider } from 'react-redux';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<Provider store={store}><App /></Provider>);

// // calling IPC exposed from preload script
// window.electron.ipcRenderer.once('ipc-example', (arg) => {
//   // eslint-disable-next-line no-console
//   console.log(arg);
// });
// window.electron.ipcRenderer.sendMessage('ipc-example', ['ping']);
